function updateAsyncEl() {

    const selector = '.tee-preview-button__text';
    const expected = 'Vista previa';

    function fix() {
        document.querySelectorAll(selector).forEach((el) => {
            if (el.textContent.trim() !== expected) el.textContent = expected;
        });
    }

    new MutationObserver(fix).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
    });

    fix();
}

updateAsyncEl();

// ===== Ficha de números con fotos (de momento solo las fichas de la lista) =====
const FICHAS_NUMERO = ['/products/numero-con-fotos-una-o-dos-cifras', '/products/prueba-numero-con-fotos-3d-una-o-dos-cifras-sueltas'];
const esFichaNumero = () => FICHAS_NUMERO.some((f) => location.pathname.indexOf(f) !== -1);
const etiquetaDesplegable = (s) => (s.closest('.product-form__input')?.querySelector('label')?.textContent || '').trim();
const desplegable = (nombre) => [...document.querySelectorAll('variant-selects select')].find((s) => etiquetaDesplegable(s) === nombre);
const OPC_CIFRAS = 'Cantidad de cifras', OPC_TAMANO = 'Tamaño', OPC_FOTOS = 'Cantidad de fotos';

// Aspecto: selector de número de Teeinblue igual que los desplegables de Shopify,
// justo debajo de ellos y sin el recuadro gris; etiquetas a la izquierda (15 px,
// texto interior 14 px); huecos de foto centrados; bloque vacío de Teeinblue
// oculto si la variante no tiene obra. El selector de número va siempre el primero
// y, mientras no se ha elegido número, no se enseña ningún hueco de foto (Teeinblue
// pinta la foto 1 de la primera plantilla encima del selector).
(function selectorNumeroComoShopify() {
    if (!esFichaNumero()) return;
    const ETIQUETA = '15px', TEXTO = '14px';
    const css = [
        '.tee-form-header{display:none!important}',
        '.tee-customize-main-form{background:transparent!important;border:0!important;border-radius:0!important}',
        '.tee-customize-main-form:not(:has(.tee-field)){display:none!important}',
        '.tee-customize-main-form .tee-form-inputs,.tee-customize-main-form .tee-customization-form{padding-left:0!important;padding-right:0!important;background:transparent!important}',
        '.tee-customization-form .tee-field--template{order:-1}',
        '.tee-customization-form:has(.tee-field--template option:first-child:checked) .tee-field--photo{display:none!important}',
        '.tee-field--template{text-align:left!important;margin:-15px 0 16px!important;padding:0!important}',
        '.tee-field--template .tee-field__header{justify-content:flex-start!important;margin:0 0 6px!important}',
        '.tee-field--template .tee-field__heading{display:block!important;text-align:left!important;font-family:Inter,sans-serif!important;font-weight:400!important;letter-spacing:0!important;color:rgba(18,18,18,.75)!important;font-size:0!important}',
        '.tee-field--template .tee-field__heading>span:first-child{letter-spacing:0!important}',
        '.tee-field--template .tee-field__heading .tee-asterisk{display:none!important}',
        '.tee-field--template .tee-field__heading>span:first-child::after{content:"Número";font-size:' + ETIQUETA + ';letter-spacing:.4px}',
        '.tee-field--template .tee-select-wrapper{position:relative}',
        '.tee-field--template .tee-field__select{width:100%!important;font-family:Inter,sans-serif!important;font-size:' + TEXTO + '!important;letter-spacing:.4px!important;color:rgba(18,18,18,.75)!important;height:45px!important;padding:0 31px 0 20px!important;border:0!important;border-radius:0!important;box-shadow:0 0 0 1px rgba(18,18,18,.55)!important;background:#fff!important}',
        '.tee-field--template .tee-field__select:hover{box-shadow:0 0 0 2px rgba(18,18,18,.55)!important}',
        '.tee-field--template .tee-select-wrapper svg{width:10px!important;right:20px!important}',
        'variant-selects .product-form__input--dropdown{align-items:flex-start!important}',
        'variant-selects .product-form__input--dropdown .select{width:100%}',
        'variant-selects .form__label{text-align:left!important;font-size:' + ETIQUETA + '!important}',
        'variant-selects label.con-grosor::after{content:" (grosor 2 cm)"}',
        'variant-selects .select__select{font-size:' + TEXTO + '!important}',
        '.tee-field--photo .tee-photo-head{justify-content:center!important}',
        '.tee-field--photo .tee-photo-label{margin-left:0!important;margin-right:0!important}'
    ].join('\n');
    const style = document.createElement('style');
    style.id = 'selector-numero-como-shopify';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
})();

// Textos dinámicos dentro de los desplegables (solo se toca lo que se ve, no la
// variante):
//  - Título "Tamaño (grosor 2 cm)": el añadido va por CSS (clase con-grosor) para
//    que el texto de la etiqueta siga siendo "Tamaño".
//  - "Tamaño": 1 cifra "22 cm de alto (15 cm de ancho)"; 2 cifras "22 cm de alto
//    (30 cm ancho total)" = las dos cifras más 0,5 cm entre ellas. Ancho de cada
//    cifra = 0,6703 × alto (proporción del recuadro de las cifras sueltas).
//  - "Cantidad de fotos": con 2 cifras "4 fotos por cifra (8 en total)" y, si esa
//    cantidad cuesta más que la estándar del tamaño, "+X €" (diferencia real de
//    precio entre esa variante y la más barata del mismo tamaño y cifras, sacada de
//    los precios de Shopify: si cambian los precios, el texto cambia solo).
//  - El aviso "no disponible" del tema se deja siempre al final.
// El tema redibuja los desplegables al cambiar de variante, así que se vuelve a
// poner; solo se toca la página si el texto cambia (sin bucles).
(function textosDinamicos() {
    if (!esFichaNumero()) return;
    const PROPORCION = 0.6703, SEPARACION_CM = 0.5;
    const noDisp = /\s*[–:-]\s*no disponible\s*$/i;
    const partes = (o) => { if (!o.dataset.orig) o.dataset.orig = o.text.trim(); return { base: o.dataset.orig.replace(noDisp, ''), extra: (o.dataset.orig.match(noDisp) || [''])[0] }; };
    const euros = (c) => (c / 100).toLocaleString('es-ES', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
    function pinta() {
        const sCifras = desplegable(OPC_CIFRAS), sTam = desplegable(OPC_TAMANO), sFotos = desplegable(OPC_FOTOS);
        const dos = !!sCifras && (sCifras.options[sCifras.selectedIndex]?.text || '').trim().startsWith('2');
        const etqTam = sTam?.closest('.product-form__input')?.querySelector('label');
        if (etqTam && !etqTam.classList.contains('con-grosor')) etqTam.classList.add('con-grosor');
        if (sTam) for (const o of sTam.options) {
            const { base, extra } = partes(o), alto = parseInt(base, 10);
            if (!alto) continue;
            const t = dos
                ? alto + ' cm de alto (' + Math.round(alto * PROPORCION * 2 + SEPARACION_CM) + ' cm ancho total)' + extra
                : alto + ' cm de alto (' + Math.round(alto * PROPORCION) + ' cm de ancho)' + extra;
            if (o.text !== t) o.text = t;
        }
        const variantes = Object.values(window.teeinblueCampaign?.variantsById || {});
        const grupo = variantes.filter((v) => v.option1 === sCifras?.value && v.option2 === sTam?.value);
        const minimo = grupo.length ? Math.min(...grupo.map((v) => v.price)) : 0;
        if (sFotos) for (const o of sFotos.options) {
            const { base, extra } = partes(o), n = parseInt(base, 10);
            if (!n) continue;
            const v = grupo.find((v) => v.option3 === o.value), mas = v ? v.price - minimo : 0;
            const t = (dos ? base + ' (' + n * 2 + ' en total)' : base) + (mas > 0 ? ' +' + euros(mas) : '') + extra;
            if (o.text !== t) o.text = t;
        }
    }
    let t;
    const programa = () => { clearTimeout(t); t = setTimeout(pinta, 150); };
    document.addEventListener('DOMContentLoaded', pinta);
    document.addEventListener('change', programa);
    new MutationObserver(programa).observe(document.documentElement, { childList: true, subtree: true });
})();

// Al elegir un tamaño se selecciona su cantidad de fotos de siempre (el cliente
// puede cambiarla después): 22→4, 30→6, 40→7, 50→8, 60→9, 75→15.
(function fotosPorDefectoSegunTamano() {
    if (!esFichaNumero()) return;
    const ESTANDAR = { 22: 4, 30: 6, 40: 7, 50: 8, 60: 9, 75: 15 };
    document.addEventListener('change', (e) => {
        if (!e.target.matches || !e.target.matches('variant-selects select') || etiquetaDesplegable(e.target) !== OPC_TAMANO) return;
        const quiero = ESTANDAR[parseInt(e.target.options[e.target.selectedIndex].dataset.orig || e.target.options[e.target.selectedIndex].text, 10)];
        if (!quiero) return;
        let intentos = 0;
        const pon = () => {
            const f = desplegable(OPC_FOTOS);
            if (!f) return;
            const o = [...f.options].find((o) => parseInt(o.dataset.orig || o.text, 10) === quiero);
            if (!o) return;
            if (f.value !== o.value) { f.value = o.value; f.dispatchEvent(new Event('change', { bubbles: true })); }
            else if (++intentos < 3) setTimeout(pon, 400);
        };
        setTimeout(pon, 600);
    }, true);
})();

// Tonos de la vista previa «Color · Blanco y negro · Sepia» en TODAS las fichas
// con personalizador de Teeinblue que tengan huecos de foto (Ramón, 2026-10-02):
// el cliente ve el diseño completo en ese tono para decidir en cuál se lo
// imprimimos. Solo cambia lo que se ve en pantalla, no el archivo que se imprime.
// El tono va SOLO en las capas que contienen una foto del cliente, no en la cifra,
// el fondo, textos ni dibujos: con un filtro sobre toda la imagen el sepia ponía
// amarillo el blanco y el gris. Teeinblue pinta la vista previa como copia (<use>)
// del diseño oculto; un filtro SVG (url) puesto en sus capas sí se ve en la copia.
// Va debajo de la imagen del producto (dentro de la galería, que es «sticky», para
// que acompañe a la imagen al bajar) y también en la ventana de «Vista previa».
(function tonosVistaPrevia() {
    if (location.pathname.indexOf('/products/') === -1) return;
    const TONOS = [['color', 'Color'], ['bn', 'Blanco y negro'], ['sepia', 'Sepia']];
    const filtros = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    filtros.setAttribute('width', '0');
    filtros.setAttribute('height', '0');
    filtros.setAttribute('aria-hidden', 'true');
    filtros.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    filtros.innerHTML = '<filter id="tono-bn" color-interpolation-filters="sRGB"><feColorMatrix type="saturate" values="0"/></filter>'
        + '<filter id="tono-sepia" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0.299 0.587 0.114 0 0 0.239 0.470 0.091 0 0 0.176 0.346 0.067 0 0 0 0 0 1 0"/></filter>';
    const ponFiltros = () => { if (!document.getElementById('tono-bn')) document.body.append(filtros); };
    // Capas del diseño que llevan una foto del cliente (no textos ni dibujos).
    const capasFoto = () => [...document.querySelectorAll('.tee-mockup-artwork > g.tee-layer-group')].filter((g) => g.querySelector('.tee-layer-photo'));
    const galeriaFicha = () => [...document.querySelectorAll('.tee-gallery-content > .tee-gallery')].find((g) => !g.closest('.vm--modal'));
    // El filtro se pone como ATRIBUTO en cada capa de foto (no con CSS): así la
    // copia (<use>) se redibuja en todos los navegadores, también Safari. Se vuelve
    // a poner cuando Teeinblue redibuja el diseño (foto nueva, otro número…).
    const marcaFotos = () => {
        const tono = document.body.dataset.tono || 'color', valor = tono === 'color' ? null : 'url(#tono-' + tono + ')';
        capasFoto().forEach((g) => {
            if (g.getAttribute('filter') === valor) return;
            if (valor) g.setAttribute('filter', valor); else g.removeAttribute('filter');
        });
    };
    // El tono elegido va al pedido en el campo «Color fotos», con los mismos textos
    // que el selector de Infinite Options (así Make y la hoja del taller lo reciben
    // igual). Si la ficha tiene ese selector de Infinite Options, se rellena y se
    // oculta; si no, se crea un campo oculto en el formulario de compra.
    const CAMPO = 'properties[Color fotos]';
    const VALORES = { color: 'Mantener el color original de mis fotos', bn: 'Convertir mis fotos a blanco y negro', sepia: 'Convertir mis fotos a Sepia' };
    const guardaColor = () => {
        const valor = VALORES[document.body.dataset.tono || 'color'];
        const io = document.querySelector('select[name="' + CAMPO + '"]');
        if (io) {
            const o = [...io.options].find((o) => o.value === valor || o.text.trim() === valor);
            if (o && io.value !== o.value) { io.value = o.value; io.dispatchEvent(new Event('change', { bubbles: true })); }
            const caja = io.closest('[class*="spb-io-field"]');
            if (caja && caja.style.display !== 'none') caja.style.display = 'none';
            // si Infinite Options cargó después, quitar el campo oculto propio (no duplicar)
            document.querySelectorAll('input[type="hidden"][name="' + CAMPO + '"]').forEach((h) => h.remove());
            return;
        }
        const form = document.querySelector('input[name="properties[_customization_id]"]')?.form || document.querySelector('product-form form[action*="/cart/add"]');
        if (!form) return;
        let h = form.querySelector('input[name="' + CAMPO + '"]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = CAMPO; form.append(h); }
        if (h.value !== valor) h.value = valor;
    };
    const aplicaTono = (tono) => { document.body.dataset.tono = tono; marcaFotos(); guardaColor(); };
    const css = [
        // tamaño de dedo: 46 px de alto (48 px en móvil, a todo el ancho)
        '.tonos-vista{display:flex;gap:8px;width:100%;max-width:420px;margin:14px auto 0;box-sizing:border-box}',
        '.tonos-vista button{flex:1;min-height:46px;padding:12px 8px;font-family:Inter,sans-serif;font-size:15px;letter-spacing:.3px;color:rgba(18,18,18,.85);background:#fff;border:0;box-shadow:0 0 0 1px rgba(18,18,18,.55);cursor:pointer;white-space:nowrap}',
        '@media (max-width:749px){.tonos-vista{max-width:none;gap:6px}.tonos-vista button{min-height:48px;padding:13px 4px}}',
        '.tonos-vista button:hover{box-shadow:0 0 0 2px rgba(18,18,18,.55)}',
        '.tonos-vista button.activo{background:#121212;color:#fff}',
        '.tee-dcontent-footer{flex-wrap:wrap}',
        '.tee-dcontent-footer .tonos-vista{width:100%;margin:0 auto 10px}'
    ].join('\n');
    const style = document.createElement('style');
    style.id = 'tonos-vista-previa';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
    const actual = () => document.body.dataset.tono || 'color';
    const refresca = () => document.querySelectorAll('.tonos-vista button').forEach((b) => b.classList.toggle('activo', b.dataset.tono === actual()));
    const crea = () => {
        const caja = document.createElement('div');
        caja.className = 'tonos-vista';
        for (const [tono, texto] of TONOS) {
            const b = document.createElement('button');
            b.type = 'button';
            b.dataset.tono = tono;
            b.textContent = texto;
            b.addEventListener('click', (e) => { e.preventDefault(); aplicaTono(tono); refresca(); });
            caja.append(b);
        }
        return caja;
    };
    function coloca() {
        // solo en fichas con galería de Teeinblue y con fotos: huecos de foto en el
        // diseño o campos para subir fotos (en la ficha del número el diseño no tiene
        // huecos hasta que se elige el número)
        const galeria = galeriaFicha();
        if (!galeria || !(capasFoto().length || document.querySelector('.tee-customization-form .tee-field--photo'))) return;
        ponFiltros();
        if (!galeria.querySelector(':scope > .tonos-vista')) galeria.append(crea());
        // solo en la ventana de «Vista previa» (la de recortar foto usa el mismo pie)
        document.querySelectorAll('.vm--modal .tee-dcontent-footer').forEach((pie) => {
            if (pie.closest('.vm--modal').querySelector('.tee-gallery-content') && !pie.querySelector('.tonos-vista')) pie.prepend(crea());
        });
        refresca();
        marcaFotos();
        guardaColor();
    }
    let t;
    const programa = () => { clearTimeout(t); t = setTimeout(coloca, 150); };
    document.addEventListener('DOMContentLoaded', coloca);
    new MutationObserver(programa).observe(document.documentElement, { childList: true, subtree: true });
})();

// Precios (Ramón, 2026-10-02), en toda la tienda: ficha de producto y tarjetas de
// producto (portada, colecciones…).
//  - El importe se ve «37.00€» (símbolo detrás, pegado y sin partir de línea) y
//    en grande; «EUR» se quita.
//  - En las tarjetas, el texto de alrededor («Desde … según tamaño») va al tamaño
//    del título del producto (13 px).
// Se reescribe el texto del precio dentro de <span class="precio-cifra"> y se
// vuelve a hacer cuando el tema redibuja el precio (al cambiar de variante, al
// cargar más productos…).
(function preciosGrandes() {
    const css = [
        '.card-information .price-item,.card__information .price-item{font-size:13px}',
        '.precio-cifra{white-space:nowrap}',
        // menos hueco gris en las tarjetas, entre la foto y el título y bajo el
        // precio (antes 10 + 17 px arriba y abajo)
        '.card-wrapper .card__information{padding-top:6px!important;padding-bottom:6px!important}',
        '.card-wrapper .card__content{padding-top:4px!important;padding-bottom:4px!important}',
        '.price--large .precio-cifra{font-size:26px;line-height:1.2}',
        '.card-information .precio-cifra,.card__information .precio-cifra{font-size:20px;line-height:1.2}',
        '@media (max-width:749px){.price--large .precio-cifra{font-size:24px}.card-information .precio-cifra,.card__information .precio-cifra{font-size:18px}}'
    ].join('\n');
    const style = document.createElement('style');
    style.id = 'precios-grandes';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
    // «€37.00 EUR», «€37.00», «37,00 €», «37,00 € EUR»…
    const IMPORTE = /€\s?(\d[\d.,]*)(\s?EUR)?|(\d[\d.,]*)\s?€(\s?EUR)?/;
    function envuelve() {
        document.querySelectorAll('.price-item').forEach((it) => {
            const w = document.createTreeWalker(it, NodeFilter.SHOW_TEXT), nodos = [];
            while (w.nextNode()) nodos.push(w.currentNode);
            nodos.forEach((n) => {
                if (n.parentElement.closest('.precio-cifra')) return;
                const m = n.nodeValue.match(IMPORTE);
                if (!m) return;
                const r = n.splitText(m.index);
                r.splitText(m[0].length);
                const sp = document.createElement('span');
                sp.className = 'precio-cifra';
                sp.textContent = (m[1] || m[3]) + '€'; // símbolo pegado (Ramón)
                r.replaceWith(sp);
            });
        });
    }
    let t;
    const programa = () => { clearTimeout(t); t = setTimeout(envuelve, 100); };
    document.addEventListener('DOMContentLoaded', envuelve);
    new MutationObserver(programa).observe(document.documentElement, { childList: true, subtree: true });
})();

// Ajustes de la portada (Ramón, 2026-10-02):
//  - Reseñas de Google (app Google Review Plus by Entangle): el logo de Google va
//    detrás del signo de verificado, en la línea de las estrellas. Arriba, junto
//    al nombre, bajaba a una línea para él solo en el móvil o se pisaba con los
//    nombres largos. No se mueve el logo de la app (para no romper el carrusel):
//    se pone una copia en la fila de estrellas y el original se oculta.
//  - Móvil: el aviso «Disponible entrega en 24h…» tiene margen respecto a la línea
//    de debajo de la cabecera (iba pegado). Se localiza por su texto.
//  - Móvil: menos hueco entre el logotipo y la línea de debajo de la cabecera.
//  - Ordenador: la mitad de margen arriba y abajo del bloque de reseñas.
(function ajustesPortada() {
    const css = [
        '.grp-entangle-item-head > .grp-entangle-item-head-logo-wrapper{display:none!important}',
        '.grp-entangle-rating .logo-junto-estrellas{display:flex!important;align-items:center;margin-left:6px}',
        '.grp-entangle-rating .logo-junto-estrellas a{display:flex;align-items:center}',
        '@media (max-width:749px){.aviso-entrega{padding-top:18px!important}}',
        // móvil: menos hueco entre el logotipo y la línea de debajo de la cabecera (eran 17,5 px)
        '@media (max-width:749px){.header{padding-bottom:2px!important}.header__heading-link{padding-bottom:0!important}}',
        // ordenador: la mitad de margen arriba y abajo del bloque de reseñas (era 40 px)
        '@media (min-width:750px){.grp-entangle--root{padding-top:20px!important;padding-bottom:20px!important}}'
    ].join('\n');
    const style = document.createElement('style');
    style.id = 'ajustes-portada';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
    function ajusta() {
        const h = [...document.querySelectorAll('.rich-text__heading')].find((e) => /Disponible entrega en 24h/i.test(e.textContent));
        const caja = h?.closest('.rich-text');
        if (caja && !caja.classList.contains('aviso-entrega')) caja.classList.add('aviso-entrega');
        document.querySelectorAll('.grp-entangle-item').forEach((it) => {
            const fila = it.querySelector('.grp-entangle-rating'), logo = it.querySelector('.grp-entangle-item-head-logo-wrapper');
            if (!fila || !logo || fila.querySelector('.logo-junto-estrellas')) return;
            const copia = logo.cloneNode(true);
            copia.classList.add('logo-junto-estrellas');
            fila.append(copia);
        });
    }
    let t;
    const programa = () => { clearTimeout(t); t = setTimeout(ajusta, 150); };
    document.addEventListener('DOMContentLoaded', ajusta);
    new MutationObserver(programa).observe(document.documentElement, { childList: true, subtree: true });
})();

// Formulario de Teeinblue con el aspecto de los desplegables de Shopify en TODAS
// las fichas con Teeinblue (Ramón, 2026-10-02), como en la ficha del número: sin
// la cabecera «AÑADE TUS FOTOS AQUÍ» ni el recuadro gris; el selector de diseño
// (número, letra…) con su título y su desplegable iguales a los de Shopify
// (título 13 px, texto 12 px, borde fino gris sin redondear, 45 px de alto), y
// siempre el primero; los huecos de foto centrados y ocultos mientras no se ha
// elegido diseño (solo si la primera opción es la vacía de Teeinblue, valor «null»).
// Se conserva el texto del título de cada ficha. La ficha del número tiene su
// propia versión (arriba) y aquí se salta.
(function formularioTeeinblueComoShopify() {
    if (location.pathname.indexOf('/products/') === -1 || esFichaNumero()) return;
    const css = [
        '.tee-form-header{display:none!important}',
        '.tee-customize-main-form{background:transparent!important;border:0!important;border-radius:0!important}',
        '.tee-customize-main-form:not(:has(.tee-field)){display:none!important}',
        '.tee-customize-main-form .tee-form-inputs,.tee-customize-main-form .tee-customization-form{padding-left:0!important;padding-right:0!important;background:transparent!important}',
        '.tee-customization-form .tee-field--template{order:-1}',
        '.tee-customization-form:has(.tee-field--template option[value="null"]:checked) .tee-field--photo{display:none!important}',
        '.tee-field--template{text-align:left!important;margin:-15px 0 15px!important;padding:0!important}',
        '.tee-field--template .tee-field__header{justify-content:flex-start!important;margin:0 0 6px!important}',
        '.tee-field--template .tee-field__heading{display:block!important;text-align:left!important;font-family:Inter,sans-serif!important;font-size:13px!important;font-weight:400!important;letter-spacing:.4px!important;color:rgba(18,18,18,.75)!important}',
        '.tee-field--template .tee-field__heading .tee-asterisk{display:none!important}',
        '.tee-field--template .tee-select-wrapper{position:relative}',
        '.tee-field--template .tee-field__select{width:100%!important;font-family:Inter,sans-serif!important;font-size:12px!important;letter-spacing:.4px!important;color:rgba(18,18,18,.75)!important;height:45px!important;padding:0 31px 0 20px!important;border:0!important;border-radius:0!important;box-shadow:0 0 0 1px rgba(18,18,18,.55)!important;background:#fff!important}',
        '.tee-field--template .tee-field__select:hover{box-shadow:0 0 0 2px rgba(18,18,18,.55)!important}',
        '.tee-field--template .tee-select-wrapper svg{width:10px!important;right:20px!important}',
        '.tee-field--photo .tee-photo-head{justify-content:center!important}',
        '.tee-field--photo .tee-photo-label{margin-left:0!important;margin-right:0!important}'
    ].join('\n');
    const style = document.createElement('style');
    style.id = 'formulario-teeinblue-como-shopify';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
})();

// ===== Opciones de Teeinblue -> propiedades visibles del pedido (15/16-10-2026) =====
// Teeinblue no manda a Shopify lo que el cliente escribe o elige en sus capas (solo el
// selector de plantilla). Para cada capa de esta lista se crea en el formulario de compra
// un campo oculto properties[<propiedad>] con lo elegido, en tiempo real:
//  - texto o párrafo: lo escrito; desplegable: el texto de la opción elegida;
//    dibujos (clipart): el nombre del dibujo elegido.
// Si la capa no está en pantalla (no aplica, p. ej. otra plantilla u otro complemento),
// está vacía o tiene el texto de ejemplo («ignorar»), la propiedad no se envía.
// Varias obras pueden usar la misma propiedad (una por tamaño): vale la que esté en pantalla.
// Para pasar otra capa más adelante: añadir una línea { obra, capa, propiedad }.
const PACK_INICIALES = { // obra: [capa del estampado, capa de la dedicatoria]
    '1333743': ['layer-984880', 'layer-371364'], // 22 cm
    '1334295': ['layer-416365', 'layer-179436'], // 30 cm
    '1334296': ['layer-631174', 'layer-613295'], // 40 cm
};
const TEXTOS_A_PEDIDO = [
    { obra: '1328447', capa: 'layer-999902', propiedad: 'Nombre escrito' }, // «Mi nombre no está»
    ...Object.entries(PACK_INICIALES).flatMap(([obra, [estampado, dedicatoria]]) => [
        { obra, capa: 'layer-300000', propiedad: 'Inicial 1' },
        { obra, capa: 'layer-300001', propiedad: 'Complemento:' }, // con dos puntos: el nombre que lee Make
        { obra, capa: 'layer-300003', propiedad: 'Inicial 2' },
        { obra, capa: estampado, propiedad: 'Estampado' },
        { obra, capa: dedicatoria, propiedad: 'Dedicatoria', ignorar: 'Escribe aquí tu dedicatoria' },
    ]),
];
(function opcionesAlPedido() {
    const formularios = () => [...document.querySelectorAll('form[action*="/cart/add"]')]
        .filter((f) => f.querySelector('input[name="id"]') && !f.classList.contains('installment'));
    const visible = (e) => !!e && (e.offsetParent !== null || e.getClientRects().length > 0);
    function valorDe(obra, capa) {
        if (!document.getElementById('tee-field--' + obra + '-template')) return '';
        const campo = document.getElementById('tee-field--' + capa);
        if (!visible(campo)) return '';
        const sel = campo.querySelector('select');
        if (sel) {
            const o = sel.options[sel.selectedIndex];
            return o && !o.disabled && o.value && o.value !== 'null' ? o.text.trim() : '';
        }
        const dibujo = campo.querySelector('.tee-clipart.active .tee-clipart-label__text');
        if (dibujo) return dibujo.textContent.trim();
        const txt = campo.querySelector('textarea, input[type="text"], input:not([type])');
        return txt ? txt.value.trim() : '';
    }
    function sincronizar() {
        const valores = {};
        TEXTOS_A_PEDIDO.forEach(({ obra, capa, propiedad, ignorar }) => {
            let v = valorDe(obra, capa);
            if (ignorar && v === ignorar) v = '';
            if (!valores[propiedad]) valores[propiedad] = v;
        });
        Object.entries(valores).forEach(([propiedad, valor]) => {
            const nombre = 'properties[' + propiedad + ']';
            formularios().forEach((f) => {
                let oculto = [...f.querySelectorAll('input[type="hidden"][data-texto-libre]')].find((i) => i.name === nombre);
                if (!valor) { if (oculto) oculto.remove(); return; }
                if (!oculto) {
                    oculto = document.createElement('input');
                    oculto.type = 'hidden';
                    oculto.name = nombre;
                    oculto.setAttribute('data-texto-libre', '1');
                    f.appendChild(oculto);
                }
                if (oculto.value !== valor) oculto.value = valor;
            });
        });
    }
    ['input', 'change', 'keyup', 'click'].forEach((ev) => document.addEventListener(ev, () => { setTimeout(sincronizar, 0); setTimeout(sincronizar, 250); }, true));
    // justo antes de añadir al carrito (submit y clic en el botón, antes que el tema)
    document.addEventListener('submit', sincronizar, true);
    document.addEventListener('click', (e) => {
        if (e.target.closest && e.target.closest('[name="add"], .product-form__submit, button[type="submit"]')) sincronizar();
    }, true);
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(sincronizar, 80); })
        .observe(document.documentElement, { childList: true, subtree: true });
    sincronizar();
})();
